import { Component, Input } from "@angular/core";

@Component({
    selector: 'app-empty-state',
    templateUrl: './empty-state.component.html',
    styleUrls: ['./empty-state.component.scss']
})
export class EmptyStateComponent {
    @Input() icon = 'fa-info-circle';
    @Input() text = 'Nothing to display';
}
